import { useMemo } from 'react';
import Levenshtein from 'fast-levenshtein';

export const useSearch = (items, search, filterBy) => {
    const distanceThreshold = 1; // Threshold for fuzzy matching, can be adjusted

    const filteredItems = useMemo(() => {
        if (!search) return items; // If there is no search term, return all items

        const searchLower = search.toLowerCase().trim();
        return items.filter((item) => {
            const fieldValue = item[filterBy]?.toString().toLowerCase();
            return (
                fieldValue.includes(searchLower) ||
                Levenshtein.get(
                    fieldValue.substring(0, searchLower.length),
                    searchLower.substring(0, fieldValue.length)
                ) <= distanceThreshold
            );
        });
    }, [items, search, filterBy]);

    return filteredItems;
};
